export enum PromiseType {	
	External = 0,
	Internal = 10
}